import { render, staticRenderFns } from "./totalWork.vue?vue&type=template&id=a1cf4d70"
import script from "./totalWork.vue?vue&type=script&lang=js"
export * from "./totalWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports